import { useEffect } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

import "../../styles/features/admin/AdminPanel.css";

export default function AdminPanel() {
  const {
    isAuthenticated,
    isLoading,
    loginWithRedirect,
  } = useAuth0();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect({
        appState: {
          returnTo:
            window.location.pathname +
            window.location.search,
        },
      });
    }
  }, [
    isLoading,
    isAuthenticated,
    loginWithRedirect,
  ]);

  if (isLoading) {
    return (
      <main className="admin-panel">
        <p>Ładowanie panelu...</p>
      </main>
    );
  }

  if (!isAuthenticated) {
    return (
      <main className="admin-panel">
        <p>Przekierowanie do logowania...</p>
      </main>
    );
  }

  return (
    <main className="admin-panel">
      <header className="admin-panel-header">
        <div>
          <h1>Panel soMeet</h1>
          <p>Zapisy i odpowiedzi z ankiet</p>
        </div>

        <nav className="admin-tabs">
          <NavLink
            to="/admin/interests"
            className={({ isActive }) =>
              isActive ? "active" : ""
            }
          >
            Zainteresowani
          </NavLink>

          <NavLink
            to="/admin/surveys"
            className={({ isActive }) =>
              isActive ? "active" : ""
            }
          >
            Ankiety
          </NavLink>
        </nav>
      </header>

      <Outlet />
    </main>
  );
}